import { userConstants } from './../constants/user.constants';

const initialState = {};

//ckyc
export function CKYC(state = initialState, action) {
  switch (action.type) {
    case userConstants.CKYC_REQUEST:
      return {
        ...state,
        loggingIn: true,
        user: action.user,
        isLoading : true

      };
    case userConstants.CKYC_SUCCESS:
        
      return {
      ...state,
        loggedIn: true,
        ckycData: action,
        isLoading : false
      };
    case userConstants.CKYC_FAILURE:
      return {
        ...state,
        isLoading : false
      };
    default:
      return state
  }
}

//digilocker
export function DIGILOCKER(state = initialState, action) {
  switch (action.type) {
    case userConstants.DIGILOCKER_REQUEST:
      return {
        loggingIn: true,
        user: action.user,
        isLoading : true

      };
    case userConstants.DIGILOCKER_SUCCESS:
        
      return {
          
        loggedIn: true,
        digiLockerData: action,
        isLoading : false
      };
    case userConstants.DIGILOCKER_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}

//pan 

export function PAN(state = initialState, action) {
  switch (action.type) {
    case userConstants.PAN_REQUEST:
      return {
        loggingIn: true,
        user: action.user,
        isLoading : true

      };
    case userConstants.PAN_SUCCESS:
        
      return {
          
        loggedIn: true,
        panStatus: action,
        isLoading : false
      };
    case userConstants.PAN_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}
export function PANPRO(state = initialState, action) {
  switch (action.type) {
    case userConstants.PANPRO_REQUEST:
      return {
        loggingIn: true,
        user: action.user,
        isLoading : true

      };
    case userConstants.PANPRO_SUCCESS:
        
      return {
          
        loggedIn: true,
        panStatus: action,
        isLoading : false
      };
    case userConstants.PANPRO_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}


export function BANKSELFIE(state = initialState, action) {
  switch (action.type) {
    case userConstants.BANK_SELFIE_REQUEST:
      return {
        loggingIn: true,
        user: action.user,
        isLoading : true

      };
    case userConstants.BANK_SELFIE_SUCCESS:
        
      return {
          
        loggedIn: true,
        bankSelfieData: action,
        isLoading : false
      };
    case userConstants.BANK_SELFIE_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}
export function PROFILE(state = initialState, action) {
  
  switch (action.type) {
    case userConstants.PROFILE_REQUEST:
      return {
        loggingIn: true,
        user: action.user,
        isLoading : true

      };
    case userConstants.PROFILE_SUCCESS:
        
      return {
          
        loggedIn: true,
        profileDetails: action,
        isLoading : false
      };
    case userConstants.PROFILE_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}
export function UPLOADEDFILES(state = initialState, action) {
  switch (action.type) {
    case userConstants.UPLOADEDFILES_REQUEST:
      return {
        loggingIn: true,
        user: action.user,
        isLoading : true

      };
    case userConstants.UPLOADEDFILES_SUCCESS:
        
      return {
          
        loggedIn: true,
        uploadedFilesDetails: action,
        isLoading : false
      };
    case userConstants.UPLOADEDFILES_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}
export function CIBIL(state = initialState, action) {
  switch (action.type) {
    case userConstants.CIBIL_REQUEST:
      return {
        loggingIn: true,
        user: action.user,
        isLoading : true

      };
    case userConstants.CIBIL_SUCCESS:
        
      return {
          
        loggedIn: true,
        cibilData: action,
        isLoading : false
      };
    case userConstants.CIBIL_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}

export function CIBILSOFT(state = initialState, action) {
  switch (action.type) {
    case userConstants.CIBILSOFT_REQUEST:
      return {
        loggingIn: true,
        user: action.user,
        isLoading : true

      };
    case userConstants.CIBILSOFT_SUCCESS:
        
      return {
          
        loggedIn: true,
        cibilSoftData: action,
        isLoading : false
      };
    case userConstants.CIBILSOFT_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}

export function POSTINCOMEPDF(state = initialState, action) {
  switch (action.type) {
    case userConstants.POST_INCOMEPROFILE_REQUEST:
      return {
        loggingIn: true,
        user: action.user,
        isLoading : true

      };
    case userConstants.POST_INCOMEPROFILE_SUCCESS:
        
      return {

        loggedIn: true,
        postIncomePdfData: action,
        isLoading : false
      };
    case userConstants.POST_INCOMEPROFILE_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}

export function GETINCOMEPROFILE(state = initialState, action) {
  switch (action.type) {
    case userConstants.GET_INCOMEPROFILE_REQUEST:
      return {
        loggingIn: true,
        user: action.user,
        isLoading : true

      };
    case userConstants.GET_INCOMEPROFILE_SUCCESS:
        
      return {

        loggedIn: true,
        getIncomePdfData: action,
        isLoading : false
      };
    case userConstants.GET_INCOMEPROFILE_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}
export function POSTFOIR(state = initialState, action) {
  switch (action.type) {
    case userConstants.POSTFOIR_REQUEST:
      return {
        loggingIn: true,
        user: action.user,
        isLoading : true

      };
    case userConstants.POSTFOIR_SUCCESS:
        
      return {

        loggedIn: true,
        postFoirData: action,
        isLoading : false
      };
    case userConstants.POSTFOIR_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}
export function GETFOIRDETAILS(state = initialState, action) {
  switch (action.type) {
    case userConstants.GETFOIR_REQUEST:
      return {
        loggingIn: true,
        user: action.user,
        isLoading : true

      };
    case userConstants.GETFOIR_SUCCESS:
        
      return {

        loggedIn: true,
        getFoirDetails: action,
        isLoading : false
      };
    case userConstants.GETFOIR_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}